import { View, Text, YStack, XStack } from 'tamagui'
import { ReactNode } from 'react'
import { Badge } from '@components/Badge'

interface IQuestionCardProps {
  questionNumber: number
  title: string
  value: number
  children: ReactNode
}

export function QuestionCard({
  questionNumber,
  title,
  value,
  children,
}: IQuestionCardProps) {
  return (
    <YStack>
      <View
        flexDirection="column"
        alignItems="flex-start"
        gap="$spacing-inset-sm"
        mb="$spacing-inset-sm"
      >
        <XStack gap="$spacing-inset-nano">
          <Text
            fontFamily="$mulishRegular"
            fontSize="$font-size-sm"
            color="$neutral-800"
            lineHeight={25}
            fontWeight={700}
          >
            {questionNumber}.
          </Text>
          <Text
            flex={1}
            textWrap="wrap"
            fontFamily="$mulishRegular"
            fontSize="$font-size-sm"
            color="$neutral-800"
            lineHeight={25}
            fontWeight="700"
          >
            {title}:
          </Text>
        </XStack>

        <View flexDirection="row" alignItems="center" gap="$spacing-inset-nano">
          <Text
            fontSize="$font-size-xs"
            color="$neutral-800"
            fontFamily="$mulishRegular"
          >
            Vale:
          </Text>
          <Badge text={`${value} pontos`} variant="info" />
        </View>
      </View>

      {children}
    </YStack>
  )
}
